import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectors, actions as poOverviewActions } from '@skunexus/purchase-order-overview';
import { getGridsSelections } from '../../core/selectors';
import { resolve } from '../../core/actions';

import Components from './ResolvePurchaseOrder';

const { getDetails, getItemsRows, getItemsIsLoading, getItemsTotalSize, getItemsRefreshToken } = selectors;

const mapStateToProps = createStructuredSelector({
    details: getDetails,
    values: getItemsRows,
    isLoading: getItemsIsLoading,
    totalSize: getItemsTotalSize,
    refreshToken: getItemsRefreshToken,
    gridSelections: getGridsSelections,
});

const mapDispatchToProps = {
    fetchRows: poOverviewActions.lineItems.fetchRows.TRIGGER,
    cancelPO: resolve.cancelPO.TRIGGER,
    cancelItems: resolve.cancelItems.TRIGGER,
};

export default connect(mapStateToProps, mapDispatchToProps)(Components);
